import { SchrankSectionHeader } from '../components/schrank/SchrankSectionHeader';
// SchrankVerwaltungPage - Mitarbeiter-Zuweisungen verwalten
// Wie Ansicht, aber Klick auf Schrank öffnet Assignment-Dialog
import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { schrankApi } from '../lib/api';
import MainLayout from '../components/layout/MainLayout';
import { Card, CardContent } from '../components/ui/card';
import { Skeleton } from '../components/ui/skeleton';
import { SchrankViewer } from '../components/schrank/SchrankViewer';

export function SchrankVerwaltungPage() {
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    schrankApi.getMyPermissions().then((res) => setPermissions(res.data))
      .catch(() => setPermissions({ can_edit_grundriss: false, can_manage_zuweisung: false }));
  }, []);

  if (!permissions) {
    return <MainLayout><Skeleton className="h-96" /></MainLayout>;
  }

  if (!permissions.can_manage_zuweisung) {
    return (
      <MainLayout>
        <Card className="border-amber-300 bg-amber-50/60">
          <CardContent className="py-12 text-center space-y-3">
            <AlertTriangle className="w-10 h-10 text-amber-600 mx-auto" />
            <h2 className="font-semibold">Keine Berechtigung</h2>
            <p className="text-sm text-muted-foreground">
              Du benötigst die Zusatzberechtigung „Schränke verwalten“ oder eine entsprechende Rolle (Admin, Wachabteilungsleitung, Wachleitung).
            </p>
          </CardContent>
        </Card>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="schrank-workspace" data-testid="schrank-verwaltung-page">
        <SchrankSectionHeader title="Verwaltung" description="Schrankbelegungen und Zuweisungen verwalten." />
        <SchrankViewer mode="verwaltung" canAssign={true} />
      </div>
    </MainLayout>
  );
}

export default SchrankVerwaltungPage;
